import type { oz } from '@weft/utils';
import { NewMeasurementSchema } from '../../entities';
import { TimeSlotSchema } from '../../primitives';

export const CreateMeasurementsPayloadSchema = NewMeasurementSchema.pick({
  customerId: true,
  meterId: true,
  value: true,
  accountId: true,
  period: true,
  latestEventUpdatedAt: true,
}).extend({
  measurementTimeSlot: TimeSlotSchema,
});

export type CreateMeasurementsPayload = oz.infer<typeof CreateMeasurementsPayloadSchema>;